import { createSlice } from '@reduxjs/toolkit';
import * as Seters from './seters';
import { IConsent } from '../../../../models/Dictionaries';

export interface State {
	consentsStage1: IConsent[];
	consentsStage2: IConsent[];
	loaded: boolean;
}

export const initialState: State = {
	consentsStage1: [],
	consentsStage2: [],
	loaded: false,
};

export const slice = createSlice({
	name: 'data/dictionaries/consents',
	initialState,
	reducers: Seters,
});

export const consentsDictReducer = slice.reducer;
const Actions = slice.actions;
export { Actions };
